import { useCallback, useEffect, useRef } from 'react';

export default function ResponsiveText({ parentRef, children, fontSize = 16 }) {
  const textRef = useRef(null);

  const adjustFontSize = useCallback(() => {
    if (parentRef.current && textRef.current) {
      const parent = parentRef.current;
      const text = textRef.current;

      // Start by increasing the font size
      text.style.fontSize = `${fontSize}px`;
      while (
        text.scrollWidth <= parent.clientWidth &&
        text.scrollHeight <= parent.clientHeight &&
        fontSize < 100
      ) {
        fontSize++;
        text.style.fontSize = `${fontSize}px`;
      }

      // Once it's too large, decrease the font size to fit
      while (
        (text.scrollWidth > parent.clientWidth ||
          text.scrollHeight > parent.clientHeight) &&
        fontSize > 1
      ) {
        fontSize--;
        text.style.fontSize = `${fontSize}px`;
      }
    }
  }, [
    parentRef.current?.clientWidth,
    parentRef.current?.clientHeight,
    textRef.current?.scrollWidth,
    textRef.current?.scrollHeight,
    fontSize,
  ]);

  useEffect(() => {
    adjustFontSize();
    const resizeObserver = new ResizeObserver(adjustFontSize);
    if (parentRef.current) {
      resizeObserver.observe(parentRef.current);
    }

    return () => {
      if (parentRef.current) {
        resizeObserver.unobserve(parentRef.current);
      }
    };
  }, [parentRef]);

  return <div ref={textRef}>{children}</div>;
}
